import React, { useState, useEffect } from "react";
import "./Table.css";
import { Globals as OldGlobals } from "../../global/Globals";
import ProposalHalfSolicated from "../HalfPage_Popup/ProposalHalfSolicated";
import ProposalHalfUnsolicated from "../../components/HalfPage_Popup/ProposalHalfUnsolicated";
import InternalHalfPageBreif from "../../components/InternalHalfPageBriefs/InternalHalfPageBriefs";
import SMHalfPageBrief from "../../components/HalfPage_Popup/SMHalfPageBrief";
import FallBackLabel from '../../global/Globals_Eng.json';
import {
  displayGenres,
  formatClusterName,
  formatProposalStatus,
  formatProposalStatusImg,
  getFilteredHeaders,
  proposols_type,
  formatStatus,
  statusImg,
} from "./tableUtils";
import { formatDate } from "../../util/util";
import CryptoUtils from "../../util/cryptoUtils";
import { DownloadBriefExcel } from "../../services/GenericAPI";
import { useLanguage } from "../../context/Languagecontext";

const Table = (props) => {
  const { Globals ,languages, setLanguages } = useLanguage();
  const [isAscending, setIsAscending] = useState(true);
  const [sortKey, setSortKey] = useState(1);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isHalfScreenPopupVisible, setIsHalfScreenPopupVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isSolicited, setIsSolicited] = useState(false);
  const [roleId, setroldId] = useState(CryptoUtils.getFromLocalStorage("roleId")?.toString());
  const [isReassignPageOpened, setReassignPagedOpened] = useState(false);
  const [sort, setSort] = useState('Ascending');
  const [isExcelDownloading, setIsExcelDownloading] = useState(null);
  
  

  useEffect(() => {
    if (isHalfScreenPopupVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isHalfScreenPopupVisible]);

  if (!props.data || props.data.length === 0) {
    return <p>No data available</p>;
  }

  let headers = getFilteredHeaders(props.data,props.form);

  const handleSort = (event) => {
    const newSortKey = props.sortKey === 1 ? 0 : 1;
    props.onSort(newSortKey);
    };

  const statusImg = (statusCode) => {
    const Title = OldGlobals.TABLE_STATUS[statusCode];
    const title = (Title.toUpperCase())?.replace(/[- ]/g, '');
    const statusImg = OldGlobals.IMG[title];
    return statusImg;
  };

  const formatStatus = (statusData) => {
    const Title = Globals.TABLE_STATUS[statusData];
    return Title;
  };

  const proposols_type = (type) => {
  
    const Proposal_Type = Globals.PROPOSALS_TYPE[type];
    return Proposal_Type;
  };

  const handleRowClick = (row) => {
    if (props.form === "myProposals" || props.form === 'internalDashboard' || (props.form === 'requests' &&  props.activeTab !== OldGlobals.REQUEST.USER_APPROVAL)) {
      setSelectedItem(row);
      setIsHalfScreenPopupVisible(!isHalfScreenPopupVisible);
    }
    if(roleId===Globals.USER_ROLES.ADMIN){
      props?.userRecord?.(row);
    }
  };

  const handleCloseHalfPage = (action) => {
    if(roleId !=="4"){
      setIsHalfScreenPopupVisible(false);
      setSelectedItem(null);
  }else{
      setSelectedItem(null);
    if(action==Globals.HALF_PAGE_BRIEF_DETAILS.ACTION_BUTTON_TEXT){
        props.onRefresh();
      }
      setIsHalfScreenPopupVisible(false);
      setReassignPagedOpened(true);
    }
  };

  const DownloadExcel =async (item,rowId)=>{
    setIsExcelDownloading(rowId);
    const ProposalId = item?.proposalId;
    const BreifNo = item?.bRefNo;
     try {
          const excelResponse = await DownloadBriefExcel(ProposalId);  
          if (excelResponse?.data) {
            const base64 = excelResponse?.data?.content;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const fileUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = BreifNo+".xlsx";
            document.body.appendChild(link);
            link.click();
            link.remove();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(fileUrl);
            setIsExcelDownloading(null);
          } else {
            console.error("Error: No file data available for download.");
            setIsExcelDownloading(null);
          }
        } catch (error) {
          console.error("Error in downloading the file:", error);
          setIsExcelDownloading(null);
        }
  }



  const formatProposalStatus = (status) => {
    const formattedstatus = status ? status.replace(/[- ]/g, '') : status;
    return formattedstatus?.toUpperCase();
  }

  const formatProposalStatusImg = (status) => {
    const title = status ? (status.toUpperCase()).replace(/[- ]/g, '') : status;
    const proposalStatusImg = Globals.IMG[title] ? Globals.IMG[title] : status;
    return proposalStatusImg;
  }

  const handleUserApproval = (status, id, name,clusterName) => {
    const popStatus = status === 0 ? "ARPPOVE_POPUP" : 'REJECT_POPUP'
    props.popupShow({
      open: true,
      title: Globals.USER_APPROVAL[popStatus].TITLE,
      toastMessage: Globals.USER_APPROVAL[popStatus].TOAST_SUCCESS,
      promptText: status === 0 ?
        <>{Globals.USER_APPROVAL[popStatus].PROMPT_TEXT1}
          <strong>{name} ?</strong>
          <br />
        </> :
        <>{Globals.USER_APPROVAL[popStatus].PROMPT_TEXT} <strong>{name} ?</strong> </>,
      ...(status === 0 ? { normalActionText: Globals.REQUEST.CTA_APPROVE } : { negativeActionText: Globals.REQUEST.CTA_REJECT }),
      body: { proposalId: id, updateFlag: status },
    })
  }

  return (
    <table>
      <thead>
        <tr>
          {headers.map((header,index) => {

            if (header === "bRefNo") {
              return (
                <th key={header} className="refno">
                  {roleId === Globals.USER_ROLES.PRODUCER ? Globals.TABLE_HEADERS.PROPOSALNO: Globals.TABLE_HEADERS.BRIEFREFNO}
                </th>
              );
            }
            if (header === "registrationNo") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.REGNO}
                </th>
              );
            }
            if (header === "BriefNo") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.BRIEFREFNO}
                </th>
              );
            }
            if (header === "channelName") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.CHANNEL}
                </th>
              );
            }
            if (header === "companyName") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.COMPANYNAME}
                </th>
              );
            }
            if (header === "name") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.NAME}
                </th>
              );
            }
            if (header === "designation") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.DESIGNATION}
                </th>
              );
            }
            if (header === "createdByHelper") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.CREATEDBY}
                </th>
              );
            }
            if (header === "contactName") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.CONTACT_NAME}
                </th>
              );
            }
            if (header === "email") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.EMAIL}
                </th>
              );
            }
            if (header === "country") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.COUNTRY}
                </th>
              );
            }
            if (header === "genre") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.GENRE}
                </th>
              );
            }
            if (header === "genre") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.GENRE}
                </th>
              );
            }
            if (header === "clusterName") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.CLUSTER}
                </th>
              );
            }
            if (header === "reportingTo") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.REPORTINGTO}
                </th>
              );
            }
            if (header === "phoneNumber") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.PHONENUMBER}
                </th>
              );
            }
            if (header === "scriptedNonScripted") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.SCRIPTEDNONSCRIPTED}
                </th>
              );
            }
            if (header === "approvalScore") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.APPROVALSCORE}
                </th>
              );
            }

            if (header === "closingDate") {
              return (
                <th key={index} className="refnoS" onClick={(e) => handleSort(e)}>
                  {Globals.TABLE_HEADERS.CLOSINGDATE}
                  <img
                    src={props.sortKey === 1 ? Globals.IMG.ARROW_DOWN_ICON : Globals.IMG.ARROW_UP_ICON}
                    alt="info icon"
                    className="icon-style arrowimg_date"
                    onClick={(e) => handleSort(e)}
                  />
                </th>
              );
            }
            if (header === "registartionDate") {
              return (
                <th key={index} className="refno" onClick={(e) => handleSort(e)}>
                  {Globals.TABLE_HEADERS.REGDATE}
                  <img
                    src={props.sortKey  === 1 ? Globals.IMG.ARROW_DOWN_ICON : Globals.IMG.ARROW_UP_ICON}
                    alt="info icon"
                    className="icon-style arrowimg_date"
                    onClick={(e) => handleSort(e)}
                  />
                </th>
              );
            }
            if (header === "registrationDate") {
              return (
                <th key={header} className="refno" onClick={(e) => handleSort(e)}>
                  {Globals.TABLE_HEADERS.REGDATE}
                  <img
                    src={props.sortKey  === 1 ? Globals.IMG.ARROW_DOWN_ICON : Globals.IMG.ARROW_UP_ICON}
                    alt="info icon"
                    className="icon-style arrowimg_date"
                    onClick={(e) => handleSort(e)}
                  />
                </th>
              );
            }
            if (header === "creationDate") {
              return (
                <th key={header} className="refnoS" onClick={(e) => handleSort(e)}>
                  {Globals.TABLE_HEADERS.CREATIONDATE}
                  <img
                    src={props.sortKey  === 1 ? Globals.IMG.ARROW_DOWN_ICON : Globals.IMG.ARROW_UP_ICON}
                    alt="info icon"
                    className="icon-style arrowimg_date"
                    onClick={(e) => handleSort(e)}
                  />
                </th>
              );
            }

            if (header === "proposalStatus") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.STATUS}
                </th>
              );
            }
            if (header === "proposalTitle") {
              return (
                <th key={header} className="refno">
                  {Globals.TABLE_HEADERS.PROPOSALTITLE}
                </th>
              );
            }
            if (header === "proposalType") {
              return (
                <th key={header} className="proposalType">
                  {Globals.TABLE_HEADERS.TYPE}
                </th>
              );
            }
            if (header === "status") {
              return (
                <th key={header} className="pstatus">
                  {Globals.TABLE_HEADERS.STATUS}
                </th>
              );
            }
            if (header === "submissionDate") {
              return (
                <th
                  key={header}
                  className={`table-sortable-header ${isAscending ? "ascending" : ""}`}
                  onClick={(e) => handleSort(e)}
                >
                  {Globals.TABLE_HEADERS.APPLICATIONDATE}
                  <img
                    src={
                      props.sortKey  === 1
                        ? Globals.IMG.ARROW_DOWN_ICON
                        : Globals.IMG.ARROW_UP_ICON
                    }
                    alt="info icon"
                    className="icon-style arrowimg_date"
                    onClick={() => { }}
                  />
                </th>
              );
            }
            if (header === "channel") {
              return (
                <th key={header} className="channel">
                  {Globals.TABLE_HEADERS.CHANNEL}
                </th>
              );
            }
            if (header === "reassignedCluster") {
              return (
                <th key={header} className="reassignedCluster">
                  {Globals.TABLE_HEADERS.REASSIGNCLUSTER}
                </th>
              );
            }

            if (header === "reassignedChannel") {
              return (
                <th key={header} className="reassignedChannel">
                  {Globals.TABLE_HEADERS.REASSIGNCHANNEL}
                </th>
              );
            }

            if (header === "reassignRequestedHelper") {
              return (
                <th key={header} className="reassignRequestedHelper">
                  {(props.activeTab === Globals.REQUEST.BRIEF_SHELVE) ? Globals.TABLE_HEADERS.SHELVEREQUESTEDBY : (props.activeTab === Globals.REQUEST.PROPOSAL_RE_ASSIGN) ? Globals.TABLE_HEADERS.REASSIGNREQUESTEDBY : Globals.TABLE_HEADERS.REQUESTEDBY}
                </th>
              );
            }

            if (header === "requestedDate") {
              return (
                <th
                  key={header}
                  className={`table-sortable-header ${isAscending ? "ascending" : ""}`}
                  onClick={(e) => handleSort(e)}>
                  {Globals.TABLE_HEADERS.REQUESTEDATE}
                  <img
                    src={
                      props.sortKey === 1 
                        ? Globals.IMG.ARROW_DOWN_ICON
                        : Globals.IMG.ARROW_UP_ICON
                    }
                    alt="info icon"
                    className="icon-style arrowimg_date"
                    onClick={(e) => handleSort(e)}
                  />
                </th>
              );
            }

            if (header === "proposalRefNo") {
              return (
                <th key={header} className="proposalRefNo">
                  {Globals.TABLE_HEADERS.PROPOSALREFNO}
                </th>
              );
            }

            if (header === "producer") {
              return (
                <th key={header} className="producer">
                  {Globals.TABLE_HEADERS.PRODUCER}
                </th>
              );
            }
            if (header === "employeeId") {
              return (
                <th key={header} className="employeeId">
                  {Globals.TABLE_HEADERS.EMPID}
                </th>
              );
            }
            if (header === "employeeName") {
              return (
                <th key={header} className="employeeName">
                  {Globals.TABLE_HEADERS.EMPNAME}
                </th>
              );
            }
            if (header === "role") {
              return (
                <th key={header} className="role">
                  {Globals.TABLE_HEADERS.ROLE}
                </th>
              );
            }
            if (header === "genre") {
              return (
                <th key={header} className="genre">
                  {Globals.TABLE_HEADERS.GENRE}
                </th>
              );
            }
          })}
          {(props.activeTab === OldGlobals.REQUEST.USER_APPROVAL) && (
            <th className="user_approval">
              {Globals.TABLE_HEADERS.APPORVEREJECT}
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {props.data.map((row, rowIndex) => (
          <tr
            key={rowIndex}
            onMouseEnter={() => setHoveredRow(rowIndex)}
            onMouseLeave={() => setHoveredRow(null)}
            onClick={() => handleRowClick(row)}
          >
            {headers
              .filter((header) => row[header] !== undefined)
              .map((header) => (
                <td key={header}>
                  {row[header] !== null && row[header] !== "" ? (
                    header === "registrationNo" ? (
                      <>
                        {row[header] ? row[header] : "N/A"}
                      </>
                    ) : header === "createdByHelper" ? (
                      <>
                        <div className="createdByname">{row[header].name}</div>
                        <div className="createdByrolename">{row[header].roleName}</div>
                      </>
                    ) : header === "reassignRequestedHelper" ? (
                      <>
                        <div className="createdByname">{row[header].name}</div>
                        <div className="createdByrolename">{row[header].roleName}</div>
                      </>
                    )
                    : header === "clusterName" ? (
                      <>
                        {row?.[header]?.length >0  ? <div className="clusterNameTable">{formatClusterName(row[header])}</div> :<div className="clusterNameTable">N/A</div>}
 
                      </>
                    ) : header === "contactName" ? (
                      <>
                        <div className="createdByname">{row[header].name}</div>
                        <div className="createdByrolename">{row[header].email}</div>
                      </>
                    ) : header === "registartionDate" ? (
                      <>
                        <div className="regDateView">
                          <div className="regDate">{formatDate(row[header])}</div>
                          <div className="regViewAction">
                            <img src={Globals.IMG.VIEW} width={20} height={20} className="cursor" />
                          </div>
                        </div>
                      </>
                    ) : header === "registrationDate" ? (
                      <>
                        <div className="regDateView">
                          <div className="regDate">{formatDate(row[header])}</div>
                          <div className="regViewAction">
                            <img
                              src={Globals.EDIT_ICON}
                              width={20}
                              height={20}
                              className="cursor"
                              onClick={()=>props.navigate(Globals.NAVPATH.UPDATE_NEW_USER, {state: { activeHeader: props.selectedTab, formValues: row}})}
                            />
                            <img
                              src={Globals.DELETE_ICON}
                              width={20}
                              height={20}
                              className="cursor"
                              onClick={()=> props.onDelete.openPopupuser(row.userId)}
                            />
                          </div>
                        </div>
                      </>
                    ) : header === "proposalStatus" ? (
                      <div className="proposalStatus">
                        <div className="name_remarks">
                          <div className="proposalStatus_header">
                            <div
                              className={`status_name ${formatProposalStatus(
                                row[header].statusEnglish
                              )}`}
                            >
                              {row[header].statusName}
                            </div>
                          </div>
                          {row[header]?.proposalStatusRemarks && (
                            <div className="status_remarks">
                              <div className="fileIcon">
                                <img
                                  src={formatProposalStatusImg(row[header].statusName)}
                                  width={20}
                                  height={20}
                                  className="cursor"
                                />
                              </div>
                              <div className="proposal_count">
                                {row[header].count ? row[header].count : ""}{" "}
                              </div>
                              <div className="remarks">{row[header].proposalStatusRemarks}</div>
                            </div>
                          )}
                        </div>
                        <div className="proposalStatus_view">
                          {row[header].statusEnglish === "Draft" ? (
                            <div className="status-actions">
                              {(roleId!==Globals.USER_ROLES.SNR_MGR && roleId !== Globals.USER_ROLES.HOP )?<><img
                                onClick={(event) => {
                                  event.stopPropagation();
                                  props.navigate(`/editnewbrief/${row.proposalId}`);
                                }}
                                src={Globals.EDIT_ICON}
                                width={20}
                                height={20}
                                className="cursor"
                              />
                              <img
                                onClick={(event) => {
                                  event.stopPropagation();
                                  props.deleteNewBrief(row);
                                }}
                                src={Globals.DELETE_ICON}
                                width={20}
                                height={20}
                                className="cursor"
                              /></>:
                              <img src={Globals.IMG.VIEW} width={20} height={20} className="cursor" />}
                            </div>
                          ) : (
                            <div className="view_download">
                          {roleId !== Globals.USER_ROLES.PRODUCER && roleId !== Globals.USER_ROLES.ADMIN &&(
                            <img src={isExcelDownloading === rowIndex ? Globals.LOADERS.SPINNING_LOADER : Globals.IMG.DOWNLOAD_ACTIVE} onClick={(event) => {
                              event.stopPropagation();
                              DownloadExcel(row,rowIndex);
                            }} width={20} height={20} className="cursor" />
                          )}
                            <img src={Globals.IMG.VIEW} width={20} height={20} className="cursor" />
                            </div>
                          )}
                          {/* <img src={Globals.IMG.VIEW} width={20} height={20} className="cursor" /> */}
                        </div>
                      </div>
                    ) : header === "bRefNo" ? (
                      <div className="proposalNo">{row[header]}</div>
                    ) :  header === "reassignedChannel" ? (
                      <>
                        <div className="proposalStatus">
                          <div className="proposalStatus_header">
                            <div className="proposalStatus mt-2">{row[header]}</div>
                          </div>
                          <div className="proposalStatus_view">
                            <img src={Globals.IMG.VIEW} width={20} height={20} className="cursor" />
                          </div>
                        </div>
                      </>
                    ) :  header === "status" ? (
                      <div className="proposal_Status">
                        <div className="status_info">
                          <img src={statusImg(row[header])} width={20} height={20} className="cursor" />
                          <button className={`status-button`} onClick={() => props.onRowClick(row)}>
                            {formatStatus(row[header])}
                          </button>
                        </div>
                        <div className="status-actions" data-visible={(row[header] === 1 || row[header] === 3) && hoveredRow === rowIndex}>
                          
                          <img onClick={(event) => {
                            event.stopPropagation();
                            if (row.proposalType == 1) {
                              props.navigate(Globals.NAVPATH.EDIT_UNSOLICITED, { state: { row } })
                            } else {
                              props.navigate(Globals.NAVPATH.EDIT_BRIEF, { state: { row } })
                            }
                          }} src={Globals.EDIT_ICON} width={20} height={20} className="cursor" />

                          {row[header] === 1 && (
                          <img onClick={(event) => {
                            event.stopPropagation();
                            if (row.proposalType == 1) {
                              props.onDelete(true, row.proposalId);
                            } else {
                              props.onSolictedDelete(true, row.proposalId);
                            }
                          }} src={Globals.DELETE_ICON} width={20} height={20} className="cursor" />
                        )}
                        </div>
                      </div>
                    ) 
                    : header === "submissionDate" ? (
                      <div>{formatDate(row[header])}</div>
                    ) : header === "requestedDate" ? (
                      <>
                      {props.activeTab === Globals.REQUEST.BRIEF_SHELVE ?
                     <div className="proposalStatus">
                          <div className="proposalStatus_header">
                            <div className="proposalStatus mt-2">{formatDate(row[header])}</div>
                          </div>
                          <div className="proposalStatus_view">
                            <img src={Globals.IMG.VIEW} width={20} height={20} className="cursor" />
                          </div>
                        </div>
                        :<div>{formatDate(row[header])}</div>}
                      </>
                    ) : header === "proposalType" ? (
                      <div>{proposols_type(row[header])}</div>
                ): header === "proposalTitle" ? (
                      <div className="td-proposal-title">{row[header]}</div>
                ) :header === "closingDate" ? (
                      <div>{row[header] === Globals.DEFAULT_MIN_DATE ? 'N/A' : formatDate(row[header])}</div>
                ):header === "expiryOn" ?(
                      <div>{formatDate(row[header])}</div>
                ):header === "genre" ? (
                  <div>{displayGenres(row[header])}</div>
                ) : header === "creationDate" ? (
                  <div className="creationDate">
                    <div className="date_creation">{formatDate(row[header])}</div>
                    <div className="creationdate-actions">
                      <img src={Globals.EDIT_ICON} width={20} height={20} className="cursor"  onClick={()=>props.navigate(Globals.NAVPATH.UPDATE_CLUSTER, {state: { activeHeader: props.selectedTab, formValues: row, update: true}})}/>
                      <img
                        src={Globals.DELETE_ICON}
                        width={20}
                        height={20}
                        className="cursor"
                        onClick={()=> props.onDelete.openPopup('delete',row.clusterId)}
                      />
                    </div>
                  </div>
                ) :
                (
                      row[header]
                    )
                ) : (
                  "N/A"
                )}
              </td>
            ))}    
            {(props.activeTab === OldGlobals.REQUEST.USER_APPROVAL) && (
             <td className="user_approval">
              <img src={OldGlobals.IMG.BLUE_CHECK} alt="Approve" className="icon-container" onClick={() => handleUserApproval(0, row.employeeId, row.employeeName,props.clusterName)} />
               <img src={OldGlobals.IMG.RED_CLOSE} alt="Reject" className="icon-container" onClick={() => handleUserApproval(1, row.employeeId, row.employeeName)} />
             </td>
            )}
          </tr>
        ))}
      </tbody>
      {isHalfScreenPopupVisible && selectedItem && (
        <div className="overlay">
          {selectedItem.proposalType == 1 && roleId === "5" ? (
            <div className="popup">
              <ProposalHalfUnsolicated
                item={selectedItem}
                onClose={handleCloseHalfPage}
                onRowClick={handleRowClick}
              /></div>
          ) : ((roleId === "2" || roleId === "6")  && props.form === 'requests') ? (
            props.activeTab !== Globals.REQUEST.USER_APPROVAL ? (
              <div className="popup sss">
                <SMHalfPageBrief
                  popupShow={props.popupShow}
                  responseData={selectedItem}
                  screenType={props.activeTab}
                  togglePopup={handleCloseHalfPage}
                />
              </div>
            ) : null
          )
            : roleId === "2" && props.form === "myProposals" ? (
                <div className="popup">
                  <ProposalHalfSolicated
                    item={selectedItem}
                    onClose={handleCloseHalfPage}
                  /></div>
              ) : (
              ((roleId !== "4") && (roleId !== "3") && (roleId !== "2") && (roleId !== "6")) ? (
                <div className="popup">
                  <ProposalHalfSolicated
                    item={selectedItem}
                    onClose={handleCloseHalfPage}
                  /></div>
              ) : (

                <div className="popup">
                  <InternalHalfPageBreif
                    item={selectedItem}
                    onClose={handleCloseHalfPage}
                    proposalIds={selectedItem}
                    popupShow={props.popupShow}
                    selectedCluster={props.ClusterInfo}
                  /></div>

              )

            )}
        </div>
      )}
    </table>
  );
};
export default Table;

